import { toast } from "react-toastify";

// Check if toast is available
const isToastAvailable = () => {
  return typeof toast !== 'undefined' && toast;
};

export const showToast = (message: string) => {
  try {
    if (!isToastAvailable()) {
      console.warn("Toast not available");
      return;
    }
    toast.dismiss();
    toast.success(message);
  } catch (error) {
    console.error("Toast error:", error);
  }
};

export const showWarning = (message: string) => {
  try {
    if (!isToastAvailable()) {
      console.warn("Toast not available");
      return;
    }
    toast.dismiss();
    toast.warn(message || "Something went wrong");
  } catch (error) {
    console.error("Toast error:", error);
  }
};

export const showError = (message: string) => {
  try {
    if (!isToastAvailable()) {
      console.warn("Toast not available");
      return;
    }
    toast.dismiss();
    toast.error(message || "Something went wrong");
  } catch (error) {
    console.error("Toast error:", error);
  }
};
